export enum PrintActionGroup {
  Dossier,
  Offer,
  Invoice,
  CreditNote,
  Allotment,
  Product,
  EntryLine,
  SelfBillingInvoice,
}
